'use client'

import { FC } from 'react'
import styles from './ComponentBodySpeakerList.module.scss'

type ChangeHandler = (value: string) => void

type EventFilterArgs = {
    value: string | null,
    onChange: ChangeHandler,
    events: readonly string[],
}

export const EventFilters: FC<EventFilterArgs> =
    ({
        value,
        onChange,
        events
    }) => {

        const eventNames = events.filter(event => event !== null && event !== undefined)

        return (
            <ul data-number={eventNames.length} className={styles.Events}>
                    <li key="all">
                        <button data-active={value===null} onClick={() => onChange("all")}>
                            All Events
                        </button>
                    </li>
                    {
                        events
                            .map( event =>
                                event === null || event === undefined ? <></> :
                                    <li key={event}>
                                        <button onClick={() => onChange(event)} data-active={value===event} data-event={event}>
                                            {event}
                                        </button>
                                    </li>
                            )
                    }
                </ul>
        )
    }
